import React, {Component} from "react";
import { Row, Col, Button, FormGroup, Label, Input } from "reactstrap";
import { inject, observer } from "mobx-react";
import FormInput from "../../../../comum/components/FormInput";
import Card from "../../../../comum/components/Card";
import FormSelect from "../../../../comum/components/FormSelect";
import { IconeDelete } from "../../../../comum/components/Icones";
import RetiradaStore from "../stores/RetiradaStore";

@inject("store")
@observer
export class RetiradaForm extends Component {
    constructor(props) {
        super(props);
        this.parametrosStore = this.props.store.parametrosStore;
        
        this.agendamentoController = this.props.agendamentoController;
        this.controller = new RetiradaStore();
    };

    componentDidMount() {
        this.controller.carregarArmadores(this.agendamentoController.tipoAgendaAtivo.value);
        if (this.agendamentoController.isEditar && ["RVI", "RVB"].indexOf(this.props.tipoAgenda)>-1){
            this.controller.carregarComboboxesBarcaca(this.agendamentoController.dadosAgendamento
                , this.agendamentoController.tipoAgendaAtivo.value
                , this.agendamentoController.agendId);
        }
            
        else
            if (this.agendamentoController.isEditar && ["RECBK", "RCDTC", "RCDICTAC", "RCDTA", "RCCRP"].indexOf(this.props.tipoAgenda)>-1) {
                this.controller.carregarComboboxesDocumentos(this.agendamentoController.dadosAgendamento);
                this.agendamentoController.carregarComboboxesDocumentosRetirada();
        }
        
        if (!this.agendamentoController.isEditar){
            this.agendamentoController.adicionarRetirada();
        }
    };

    botaoAdicionar(titulo) {
        return <Button onClick={ this.handleAdicionarClick } className="btn-com-bordas-primary">{titulo}</Button>;
    };

    handleAdicionarClick = () => {
        if ((this.props.tipoAgenda ==="RVI" || this.props.tipoAgenda === "RVB") && process.env.rig) {
            this.agendamentoController.adicionarRetiradaVazioRig(); 
            this.controller.adicionaNovoItemRetirada();
            this.controller.carregarArmadores(this.agendamentoController.tipoAgendaAtivo.value, 
                                              this.controller.armadores.length-1);
        } else {
            this.agendamentoController.adicionarRetirada(); 
        }
    }

    campoContainer(dado, md) {
        if (this.parametrosStore.isAgendamentoVisible("ListaContainerContainer"))
            return <FormInput titulo="Container" xs={12} sm={12} md={md}
                objeto={ this.agendamentoController.dadosAgendamento }
                dado={ dado } uppercase={true}
                bloqueado={ !this.parametrosStore.isAgendamentoEnabled("ListaContainerContainer") }
                onChange={ (event) => this.agendamentoController.setDadosAgendamento(dado, event) } />;
    };

    campoInput(titulo, dado, md, parametro) {
        if (this.parametrosStore.isAgendamentoVisible(parametro))
            return <FormInput titulo={ titulo } xs={12} sm={12} md={md}
                objeto={ this.agendamentoController.dadosAgendamento }
                dado={ dado }
                bloqueado={ !this.parametrosStore.isAgendamentoEnabled(parametro) }
                onChange={ (event) => this.agendamentoController.setDadosAgendamento(dado, event) } />;
    };

    campoInputSemParametros(titulo, dado, md) {
        return <FormInput titulo={ titulo } xs={12} sm={12} md={md}
            objeto={ this.agendamentoController.dadosAgendamento }
            dado={ dado }
            onChange={ (event) => this.agendamentoController.setDadosAgendamento(dado, event) } />;
    };

    campoQuantidade(dado, md) {
        if (this.parametrosStore.isAgendamentoVisible("ListaContainerQuantidade"))
            return <FormInput   titulo="Quantidade" xs={12} sm={12} md={md} type="number"
                                objeto={ this.agendamentoController.dadosAgendamento }
                                dado={ dado }
                                bloqueado={ !this.parametrosStore.isAgendamentoEnabled("ListaContainerQuantidade") }
                                onChange={ (event) => this.agendamentoController.setDadosAgendamento(dado, event) } 
                    />;
    };

    campoArmador(dado, md, index) {
        return <FormSelect  sm={12} xs={12} md={md} titulo="Armador"
                            bloqueado={ !this.parametrosStore.isAgendamentoEnabled("ListaContainerArmador") }
                            itens={ this.controller.armadores[index] }
                            objeto={ this.agendamentoController.dadosAgendamento }
                            dado={ dado }
                            itensValor="ArmId" itensLabel="Idlineop"
                            onChange={ (event) => this.handleChangeArmadores(dado, event, index) } 
                />;
    };

    handleChangeArmadores = (dado, event, index) => {
        this.agendamentoController.setDadosAgendamento(`listaBookings[0].containers[${index}].VesselvisitId`, null);
        this.agendamentoController.setDadosAgendamento(`listaBookings[0].containers[${index}].CdTipoCntr`, null);
        this.agendamentoController.setDadosAgendamento(`listaBookings[0].containers[${index}].ShipmentNumber`, null);
        this.controller.container[index] = [];
        this.controller.carregarOperacoes(event, this.agendamentoController.tipoAgendaAtivo.value, index);
        this.controller.armadorSelecionado[index] = event;
        this.agendamentoController.setDadosAgendamento(dado, event);
    };

    campoOperacao(dado, md, index) {
        return <FormSelect  xs={12} sm={12} md={md} titulo="Operação"
                                bloqueado={ !this.controller.operacoes[index] || !this.parametrosStore.isAgendamentoEnabled("ListaContainerOperacao") }
                                itens={ this.controller.operacoes[index] }
                                objeto={ this.agendamentoController.dadosAgendamento }
                                dado={ dado }
                                itensValor="Vesselvisitid" itensLabel="Visitanavio"
                                onChange={ (event) => this.handleChangeOper(dado, event, index) } 
                    />;
    };

    handleChangeOper = (dado, event, index) => {
        this.agendamentoController.setDadosAgendamento(`listaBookings[0].containers[${index}].CdTipoCntr`, null);
        this.agendamentoController.setDadosAgendamento(`listaBookings[0].containers[${index}].ShipmentNumber`, null);
        this.controller.container[index] = [];
        this.controller.operacaoSelecionado[index] = event;
        this.controller.carregarTiposCntr(event, index);
        this.agendamentoController.setDadosAgendamento(dado, event);
    };

    campoTipoCntr(dado, md, index) {
        return <FormSelect  xs={12} sm={12} md={md} titulo="Tipo"
                            bloqueado={ (!this.controller.tiposCntrVisible[index]) || !this.parametrosStore.isAgendamentoEnabled("ListaContainerTipoCNTR") }
                            itens={ this.controller.tiposCntr[index] }
                            objeto={ this.agendamentoController.dadosAgendamento }
                            dado={ dado }
                            itensValor="Typeisoid" itensLabel="Typeisoid"
                            onChange={ (event) => this.handleChangeTipoCntr(dado, event, index) } 
                />;
    };

    handleChangeTipoCntr = (dado, event, index) => {
        this.controller.tipoCntrSelecionado[index] = event;
        this.controller.carregarShipment(event, index);
        this.controller.carregarContainer(event, this.agendamentoController.isEditar ? this.agendamentoController.agendId : 0, index);
        this.agendamentoController.setDadosAgendamento(dado, event);
    };

    campoShipmentNumber(dado, md, index) {
        return <FormSelect xs={12} sm={12} md={md} titulo="Shipment Number"
            bloqueado={  !this.controller.shipmentsVisible[index] && (!this.controller.shipments[index] || this.controller.shipments[index].length === 0) }
            itens={ this.controller.shipments[index] }
            objeto={ this.agendamentoController.dadosAgendamento }
            dado={ dado }
            itensValor="CustdffSn" itensLabel="CustdffSn"
            onChange={ (event) => this.agendamentoController.setDadosAgendamento(dado, event) } />;
    };

    campoContainerVazio(md, index) {
        return <Col xs={12} sm={12} md={md}>
            <FormGroup>
                <Label>Quantidade Disponível</Label>
                <Input defaultValue={ this.controller.container[index] }
                    disabled = {true} />
            </FormGroup>
        </Col>;
    };

    campoQuantidadeVazio(dado, md) {
        if (this.parametrosStore.isAgendamentoVisible("ListaContainerQuantidade"))
            return <FormInput titulo="Quantidade" xs={12} sm={12} md={md} type="number"
                objeto={ this.agendamentoController.dadosAgendamento }
                dado={ dado }
                onChange={ (event) => this.agendamentoController.setDadosAgendamento(dado, event) } />;
    };

    campoBooking(dado, md) {
        if (this.parametrosStore.isAgendamentoVisible("ListaContainerBooking"))
            return <FormInput titulo="Booking" xs={12} sm={12} md={md}
                objeto={ this.agendamentoController.dadosAgendamento }
                dado={ dado } uppercase={true}
                bloqueado={ !this.parametrosStore.isAgendamentoEnabled("ListaContainerBooking") }
                onChange={ (event) => this.agendamentoController.setDadosAgendamento(dado, event) } />;
    };

    campoDocumentos(titulo, dado, md, parametro, tipoAgendaId=null) {
        if (tipoAgendaId===this.agendamentoController.tipoAgendaAtivo.value)
            return <FormSelect xs={12} sm={12} md={md} titulo={ titulo }
                           itens={ this.agendamentoController.documentosRetirada }
                           objeto={ this.agendamentoController.dadosAgendamento }
                           dado={ `${dado}.containers[0].DiRetirada` }
                           bloqueado={ this.agendamentoController.isEditar || !this.agendamentoController.documentosRetirada }
                           itensValor="NumeroDi" itensLabel="NumeroDi"
                           onChange={ (event) => this.handleChangeDocumento(dado, event) } />;
    };

    handleChangeDocumento = (dado, event) => {
        if (event==null) this.controller.containers = false;
        this.agendamentoController.carregarContainersDocumentosRetiradas(dado, event);
        this.agendamentoController.setDadosAgendamento(`${dado}.containers[0].DiRetirada`, (event!=null ? {value: event.label} : null));
        this.agendamentoController.dadoFoiSelecionado(event);
    };

    campoSelectContainers(dado, booking, md) {
        if (this.agendamentoController.atualizaRetiradas)
            return <FormSelect xs={12} sm={12} md={md} titulo="Container"
                       itens={ _.get(this.agendamentoController.dadosAgendamento, `${booking}.ContainersDocumentos`) }
                       objeto={ this.agendamentoController.dadosAgendamento }
                       dado={ dado }
                       bloqueado={ this.agendamentoController.isEditar || !this.agendamentoController.dadoDocumentoSelecionado }
                       itensValor="Container" itensLabel="Container"
                       onChange={ (event) => this.agendamentoController.setDadosAgendamento(dado, event) } />;
    };

    cardVazio(titulo) {
        return <div>
            <Row>
                <Col>
                    <h2>{ titulo }</h2>
                </Col>
                { this.botaoAdicionar("Novo") }
            </Row>
            <Row>
                { this.agendamentoController.atualizaRetiradas
                    && this.agendamentoController.dadosAgendamento.listaBookings
                    && this.agendamentoController.dadosAgendamento.listaBookings.map((book, x) =>
                    <Col className="area-form card-form" xl={6} key={x}>
                        <Card>
                            <Row>
                                { this.campoBooking(`listaBookings[${x}].NumBooking`, 6) }
                                { this.campoQuantidade(`listaBookings[${x}].containers[0].QtdRetirada`, 6) }
                            </Row>
                        </Card>
                        <IconeDelete className="icone-delete-borda" tamanho="3x" onClick={ () => this.agendamentoController.removerRetirada(x) } />
                    </Col>
                )}
            </Row>
        </div>
    };

    cardBookCntr(titulo) {
        return <div>
            <Row>
                <Col>
                    <h2>{ titulo }</h2>
                </Col>
                { this.botaoAdicionar("Novo Container") }
            </Row>
            <Row>
                { this.agendamentoController.atualizaRetiradas
                    && this.agendamentoController.dadosAgendamento.listaBookings
                    && this.agendamentoController.dadosAgendamento.listaBookings.map((book, x) =>
                    <Col className="area-form card-form" xl={6} key={x}>
                        <Card>
                            <Row>
                                { this.campoBooking(`listaBookings[${x}].NumBooking`, 6) }
                                { this.campoContainer(`listaBookings[${x}].containers[0].CodCntr`, 6) }
                            </Row>
                        </Card>
                        <IconeDelete className="icone-delete-borda" tamanho="3x" onClick={ () => this.agendamentoController.removerRetirada(x) } />
                    </Col>
                )}
            </Row>
        </div>
    };

    cardDTC() {
            return <div>
                <Row>
                    <Col>
                        <h2>Retirada DTC</h2>
                    </Col>
                    { this.botaoAdicionar("Novo Booking") }
                </Row>
                <Row>
                { this.agendamentoController.atualizaRetiradas
                    && this.agendamentoController.dadosAgendamento.listaBookings
                    && this.agendamentoController.dadosAgendamento.listaBookings.map((book, x) =>
                        <Col className="area-form card-form" xl={6} key={x}>
                            <Card>
                                <Row>
                                    { this.campoBooking(`listaBookings[${x}].NumBooking`, 6) }
                                    { this.campoQuantidade(`listaBookings[${x}].containers[0].QtdRetirada`, 6) }
                                </Row>
                            </Card>
                            { <IconeDelete className="icone-delete-borda" tamanho="3x" onClick={ () => this.agendamentoController.removerRetirada(x) } /> }
                        </Col>
                )}
                </Row>
            </div>
    };

    cardRECBK() {
            return <div>
                <Row>
                    <Col>
                        <h2>Retirada por Booking</h2>
                    </Col>
                    { this.botaoAdicionar("Novo Booking") }
                </Row>
                <Row>
                { this.agendamentoController.atualizaRetiradas
                    && this.agendamentoController.dadosAgendamento.listaBookings
                    && this.agendamentoController.dadosAgendamento.listaBookings.map((book, x) =>
                        <Col className="area-form card-form" xl={6} key={x}>
                            <Card>
                                <Row>
                                    { this.campoBooking(`listaBookings[${x}].NumBooking`, 6) }
                                    { this.campoQuantidade(`listaBookings[${x}].containers[0].QtdRetirada`, 6) }
                                </Row>
                            </Card>
                            { <IconeDelete className="icone-delete-borda" tamanho="3x" onClick={ () => this.agendamentoController.removerRetirada(x) } /> }
                        </Col>
                )}
                </Row>
            </div>
    };

    form() {
        switch (this.props.tipoAgenda) {
            case "RCV":
            case "23RCV":
                return this.cardVazio("Retirada Vazio");
            case "RCDICTAC":
                return this.cardBookCntr("Retirada DI/CTAC");
            case "RCDTA":
                return this.cardBookCntr("Retirada DTA");
            case "RCDTC":
                return this.cardDTC();
            case "RECBK":
                return this.cardRECBK();
            default:
                break;
        }
    };

    render() {
        return (
            <div>
                { this.form() }
            </div>
        );
    };
}



// WEBPACK FOOTER //
// ./src/modules/agendamento/containers-cadastrar/retirada-containers/components/RetiradaForm.js